<template>
  <div>
    <m-geo-count />
    <m-content>
      <div class="box">
        <div class="the-slide" v-show="this.$route.name !== 'success'">
          <m-slide />
        </div>
        <div class="the-content">
          <keep-alive v-if="!$route.meta.keepUnAlive">
            <router-view />
          </keep-alive>
          <router-view v-if="$route.meta.keepUnAlive"></router-view>
        </div>
      </div>
    </m-content>
  </div>
</template>

<script>
import MContent from "@/components/layouts/MContent";
import MGeoCount from "@/components/Geo/MGeoCount.vue";
import MSlide from "@/components/slide/MSlide.vue";

export default {
  components: {
    MContent,
    MGeoCount,
    MSlide,
  },
  data() {
    return {};
  },
  computed: {
    dataSource() {
      return this.$store.getters["config/datasource"];
    },
    recommendDemos() {
      return this.$store.state.demo.recommendDemos || [];
    },
    getCountId() {
      return this.$store.state.summary.getCountId || false;
    },
  },
  watch: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.box {
  display: flex;
  flex-wrap: nowrap;
}

.the-content {
  width: 100%;
  flex-grow: 0;
}

@media (max-width: 991px) {
  .the-slide {
    display: none;
  }
}

@media (max-width: 1000px) {
  .the-slide {
    width: 40%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/Order1.vue